import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const COUNTRY_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/country';
const settingsServiceName = "Country-Service: ";

export default class CountryService {

    static async readAllCountriesPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(COUNTRY_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveCountry(country, isEdit, successF, errorF) {
        if (!isEdit) {
            await WrapperService.post(COUNTRY_API_URL, country, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(COUNTRY_API_URL + '/' + country.id, country, settingsServiceName, successF, errorF);
        }
    }
}